/** Algeria is UTC+01:00 year-round (no DST). */
export const ALGIERS_TZ = 'Africa/Algiers';

/** "YYYY-MM-DDTHH:mm" (datetime-local, Algiers wall time) -> ISO instant with explicit offset. */
export function algiersInputToIso(input: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(input)) return null;
  return `${input.slice(0, 16)}:00+01:00`;
}

/** ISO instant -> "YYYY-MM-DD" in Algiers wall time.
 *
 *  Sorts lexicographically, so two keys compare as calendar days: c'est ce qu'il faut pour
 *  décider « cette visite est en retard », qui est une question de jour civil algérien et
 *  non d'instant (une visite prévue ce matin à 9h n'est pas « en retard » à 10h). */
export function algiersDayKey(iso: string | number | Date | null | undefined): string {
  if (iso === null || iso === undefined || iso === '') return '';
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  // en-CA rend directement YYYY-MM-DD.
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: ALGIERS_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d);
}

/** ISO instant -> "YYYY-MM-DDTHH:mm" in Algiers wall time, for datetime-local inputs. */
export function isoToAlgiersInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: ALGIERS_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(d);
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '';
  const hour = get('hour') === '24' ? '00' : get('hour');
  return `${get('year')}-${get('month')}-${get('day')}T${hour}:${get('minute')}`;
}

/** ISO instant -> "HH:mm" in Algiers wall time (« depuis 10:31 »). */
export function algiersClock(iso: string | null | undefined): string {
  return isoToAlgiersInput(iso).slice(11, 16);
}
